/** The public site address, used for canonical URLs and the sitemap. Set it at build time. */
export const SITE_URL = (
  process.env.NEXT_PUBLIC_SITE_URL ?? "https://zmanim.slrtech.co.il"
).replace(/\/$/, "");

export const SITE_NAME = "כדעת";

/** Where reports of a wrong zman go. Set it at build time. */
export const CONTACT_EMAIL = process.env.NEXT_PUBLIC_CONTACT_EMAIL ?? "dev@slr-slr.com";

/**
 * Title, description, canonical URL and link-preview tags for one page. Next replaces the
 * whole openGraph object when a page sets it, so every page builds it through here rather
 * than inheriting a preview that names the home page.
 */
export function pageMetadata({
  title,
  description,
  path,
}: {
  title: string;
  description: string;
  /** Absolute path with a trailing slash, e.g. "/luach/". */
  path: string;
}) {
  return {
    title,
    description,
    alternates: { canonical: path },
    openGraph: {
      siteName: SITE_NAME,
      locale: "he_IL",
      type: "website" as const,
      title: path === "/" ? title : `${title} · ${SITE_NAME}`,
      description,
      url: path,
      images: [{ url: "/og.png", width: 1200, height: 630, alt: `${SITE_NAME} — זמני היום בהלכה` }],
    },
  };
}
